var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.image)?_c('v-img',{attrs:{"src":_vm.image},on:{"error":function($event){_vm.loadingError=true}}},[_c('fin-logo-sign',{attrs:{"slot":"placeholder","dark":_vm.dark,"loading":"","size":"100%"},slot:"placeholder"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }